import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Faq() {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" aria-labelledby="faq-title" className="scroll-mt-20 bg-white py-24 md:py-32" data-id="element-93" data-mp="1gdgzpcni0i27">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 md:px-10 lg:grid-cols-12 lg:gap-20" data-id="element-94" data-mp="2e0pr1oa6klc4">
        <div className="lg:col-span-4" data-id="element-95" data-mp="2913c9aepex17">
          <h2 id="faq-title" className="font-display text-[30px] font-medium tracking-[-0.01em] text-ink md:text-[36px]" data-id="element-96" data-mp="2924nbevpzjix">
            {t.faq.title}
          </h2>
          <p className="mt-5 text-[17px] text-muted" data-id="element-97" data-mp="1z2xcozgde2zi">{t.faq.intro}</p>
          <a href="#contact" className="mt-6 inline-flex min-h-[44px] items-center text-[15px] font-semibold text-violet underline decoration-violet/30 underline-offset-4 transition-colors duration-200 hover:decoration-violet" data-id="element-98" data-mp="so6409l09dux">
            {t.faq.contactLink}
          </a>
        </div>

        <ul className="lg:col-span-8" data-id="element-99" data-mp="ugiu4ydlhj8b">
          {t.faq.items.map((item, i) => {
          const open = openIndex === i;
          const id = `faq-panel-${i}`;
          return <li key={item.q} className="border-t border-mist last:border-b" data-id="element-100" data-mp="khjvm8mjn3z1" data-mpi={i}>
                <h3 data-id="element-101" data-mp="6qf09iq7kxui">
                  <button type="button" aria-expanded={open} aria-controls={id} id={`${id}-trigger`} onClick={() => setOpenIndex(open ? null : i)} className="flex min-h-[72px] w-full items-center justify-between gap-6 py-5 text-left font-display text-[18px] font-medium text-ink transition-colors duration-200 hover:text-violet" data-id="element-102" data-mp="6pvic20k69gh">
                    {item.q}
                    <PlusIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-violet transition-transform duration-200 ease-out ${open ? 'rotate-45' : ''}`} data-id="element-103" data-mp="3nz1zk4z73qu6" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-104" data-mp="1koypqom3srnx">
                  {open && <motion.div id={id} role="region" aria-labelledby={`${id}-trigger`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-105" data-mp="1ftj95owpohnt">
                      <p className="max-w-2xl pb-7 pr-10 text-[16.5px] text-muted" data-id="element-106" data-mp="s35ia1pv4out">{item.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}